import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";
import { downloadExcel } from "react-export-table-to-excel";
import toast, { Renderable, Toast, ValueFunction } from "react-hot-toast";

export const utils = {
  isArrayEmpty(array: any) {
    return (
      array === undefined ||
      array === "" ||
      array === null ||
      array.length === 0 ||
      !Array.isArray(array)
    );
  },

  isStringEmpty(str: any) {
    return (
      str === "" ||
      !str ||
      str === undefined ||
      str === null ||
      str === "NaN" ||
      str === 0
    );
  },

  isObjectEmpty(object: any) {
    return (
      object === undefined ||
      object === null ||
      object === "" ||
      Object.keys(object).length === 0
    );
  },

  isValidEmail(num: any) {
    var re =
      // eslint-disable-next-line no-useless-escape
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(num);
  },

  hasSpecialCharaters(str: any) {
    if (this.isStringEmpty(str)) {
      return false;
    }
    const iChars = "~`!#$%^&*+=-@[]\\';,/{}|\":<>?";
    for (let i = 0; i < str.length; i++) {
      if (iChars.indexOf(str.charAt(i)) > -1) {
        return true;
      }
    }
    return false;
  },

  generateRandomID() {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    const charactersLength = characters.length;
    for (let i = 0; i < 4; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  },

  onSearch(array: any[], keys: any[], text: string) {
    const finalArray = [...array];
    if (this.isStringEmpty(text) || this.isArrayEmpty(keys)) {
      return finalArray;
    }
    return finalArray.filter((item) => {
      const startsWith = keys.map((object) =>
        String(item[object])?.toLowerCase().includes(text?.toLowerCase())
      );
      if (startsWith.includes(true)) {
        return item;
      } else return null;
    });
  },
  getServicesLabel(services: any[]) {
    if (this.isArrayEmpty(services)) {
      return "N/A";
    }
    return services
      ?.map((item: { label: any; name: any }) => item.label || item.name)
      .filter(Boolean)
      .join(", ");
  },
  getMultiCitiesLabel(cities: any[]) {
    if (this.isArrayEmpty(cities)) {
      return "N/A";
    }
    return cities
      ?.map((item: { name: any }) => item.name)
      .filter(Boolean)
      .join(", ");
  },
  getMultiServiceProviderLabel(serviceProviders: any[]) {
    if (this.isArrayEmpty(serviceProviders)) {
      return "N/A";
    }
    return serviceProviders
      ?.map((item: { loginName: any }) => item.loginName)
      .filter(Boolean)
      .join(", ");
  },
  getMomentDate(date: any, type: any | undefined) {
    return moment(date).format(type || "DD-MM-YYYY");
  },
  isValidDate(date: any) {
    return moment(date, "DD-MM-YYYY", true).isValid();
  },
  exportAsExcel(header: any[], body: any[], fileName: string) {
    const timestamp = new Date().getTime();
    const uniqueFileName = `${fileName}_${timestamp}`;
    downloadExcel({
      fileName: uniqueFileName,
      sheet: fileName,
      tablePayload: { header, body },
    });
  },
  exportAsPDF(head: any[], body: any[], fileName: string) {
    const pdf = new jsPDF("p", "pt");
    // autoTable(pdf, { html: "#my-table" });
    pdf.addPage();
    pdf.deletePage(1);
    pdf.internal.pages = [1];
    pdf.setPage(1);

    autoTable(pdf, { head: [head], body });

    const timestamp = new Date().getTime();
    const uniqueFileName = `${fileName}_${timestamp}.pdf`;

    pdf.save(`${uniqueFileName}.pdf`);
  },

  setSession(accessToken: string | null) {
    if (accessToken) {
      localStorage.setItem("accessToken", accessToken);
      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    } else {
      localStorage.removeItem("accessToken");
      delete axios.defaults.headers.common.Authorization;
    }
  },
  toastSuccess(message: Renderable | ValueFunction<Renderable, Toast>) {
    toast.success(message);
  },
  toastError(message: Renderable | ValueFunction<Renderable, Toast>) {
    toast.error(message);
  },
  confirmAlert(message: string) {
    return window.confirm(message);
  },
};
